import { Constructor } from 'interfaces/constructor';
import { Func } from 'interfaces/func';
import { WCCContentBlock } from '../blocks/block/block';

function cutRight(content: string, length: number) {
    return content.substr(0, length);
}

export interface MakeWCCContentBlockWithLimitConfig {
    cut?: Func<string, [content: string, length: number]>,
    maxLength?: number
}

export function MakeWCCContentBlockWithLimit(config: MakeWCCContentBlockWithLimitConfig = {}) {
    const { cut: cutFunc = cutRight, maxLength = 0 } = config;

    return function MakeWCCContentBlockWithLimit<TBase extends Constructor<any[], WCCContentBlock>>(Base: TBase) {
        abstract class ExtendedWCCContentBlock extends Base {
            override take(length: number) {
                if (maxLength > 0 && length > maxLength)
                    length = maxLength;
                
                return this.clone({ content: cutFunc(this.content, length) });
            }
        }

        return ExtendedWCCContentBlock;
    }
}